import React, { useCallback } from "react";
import { Navbar } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { OnlineLink } from "components";
import { URLS } from "globalConstants";

import MenuItem from "./menuItem";
import { getSideMenuItems } from "./sideMenuItems";

import { ReactComponent as Logo } from "static/images/riseCrm.svg";
import styles from "./sidebar.module.scss";

const SideMenu = () => {
	const history = useHistory();

	const handleLogout = useCallback(() => {
		history.replace(URLS.logout);
	}, [history]);

	return (
		<Navbar className={styles.sidebar}>
			<OnlineLink to="/" className={styles.logoContainer}>
				<Logo />
			</OnlineLink>
			{getSideMenuItems().map(props => {
				const menuItemKey = props.to;
				return <MenuItem key={menuItemKey} {...props} />;
			})}
			<button
				type="button"
				className={styles.logoutBtn}
				onClick={handleLogout}
			>
				Logout
			</button>
		</Navbar>
	);
};

export default SideMenu;
